/**
 * Set up global functions.
 */

// If JavaScript is enabled, swap class on html element.
const el = document.getElementsByTagName('html')[0];
el.classList.add('js');
el.classList.remove('no-js');

jQuery(($) => {
  function doneAnimating() {
    $('html').addClass('animated-in');
  }

  function doneResizing() {
    $('body').removeClass('resizing');
  }

  let resizeId;
  $(window).on('resize', () => {
    clearTimeout(resizeId);
    if (!$('body').hasClass('resizing')) {
      $('body').addClass('resizing');
    }
    resizeId = setTimeout(doneResizing, 500);
  });

  let loadId;
  $(window).on('load', () => {
    clearTimeout(loadId);
    loadId = setTimeout(doneAnimating, 2500);
  });

  $('#mobile-btn').on('click', () => {
    $(this).toggleClass('active');
    $('.nav-main').toggleClass('show');
    $('body').toggleClass('no-scroll');
  });
});
